export default __webpack_public_path__ + "static/media/jee_mock_legacy_mobile.403fe7c9.webp";